/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isNone } from '@ember/utils';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import { SplitMetric } from 'cio/utils/metrics/models/split-metric';
import { VariationBadge } from 'cio/models/action';
import { findDenominator, MeasureType } from 'cio/utils/metrics/measure';

interface CampaignSplitPerformanceTableRowArgs {
  metric: SplitMetric;
  badge: VariationBadge;
  name: string;
  originalMetric: SplitMetric;
  availableMeasures: { key: string; title: string }[];
}
export default class CampaignSplitPerformanceTableRow extends Component<CampaignSplitPerformanceTableRowArgs> {
  @service store!: DS.Store;

  get denominator() {
    return findDenominator('converted', MeasureType.DeliveryMetrics, 'email_action');
  }

  get showCanTrackOpens() {
    if (this.actionModel?.type !== 'push_action') {
      return false;
    }

    let openedMeasure = (this.args.availableMeasures ?? []).findBy('key', 'opened');

    if (isNone(openedMeasure)) {
      return false;
    }

    return this.args.metric.opened.total === 0;
  }

  get actionModel() {
    if (!this.args.metric.actionId) {
      return null;
    }

    return this.store.peekRecord('action', this.args.metric.actionId);
  }
}
